export default __webpack_public_path__ + "static/media/dec-21.14ab19f9.jpg";